import React from 'react';

import { Typography } from '@lyearn/ui';
import { useScorecard } from '@/modules/corporate/modules/scorecards/components/Scorecard/Scorecard';

import { NameProps } from '../types';

function Name(props: NameProps) {
  const { variant = 'label-02', className = 'overflow-hidden text-ellipsis' } = props;
  const [scorecard] = useScorecard();

  if (!scorecard) {
    return null;
  }

  const { title } = scorecard;

  return (
    <Typography className={className} variant={variant}>
      {title}
    </Typography>
  );
}

export default React.memo(Name);
